
const nameByRole = {
  member: '一般ユーザー',
  manager: '管理者',
  parent: '保護者'
}

export const getRoleName = (role) => {
  return nameByRole[role]
}
